/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Transcript_TitleInputs */

const en_file_export_transcript_title = /** @type {(inputs: File_Export_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcript`)
};

const fr_file_export_transcript_title = /** @type {(inputs: File_Export_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription`)
};

const de_file_export_transcript_title = /** @type {(inputs: File_Export_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkript`)
};

const it_file_export_transcript_title = /** @type {(inputs: File_Export_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione`)
};

const ru_file_export_transcript_title = /** @type {(inputs: File_Export_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стенограмма`)
};

const es_file_export_transcript_title = /** @type {(inputs: File_Export_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción`)
};

const zh_cn2_file_export_transcript_title = /** @type {(inputs: File_Export_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字稿`)
};

const ja_file_export_transcript_title = /** @type {(inputs: File_Export_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプト`)
};

const hi_file_export_transcript_title = /** @type {(inputs: File_Export_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलिपि`)
};

const pt_pt2_file_export_transcript_title = /** @type {(inputs: File_Export_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição`)
};

/**
* | output |
* | --- |
* | "Transcript" |
*
* @param {File_Export_Transcript_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_transcript_title = /** @type {((inputs?: File_Export_Transcript_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Transcript_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_transcript_title(inputs)
	if (locale === "de") return de_file_export_transcript_title(inputs)
	if (locale === "it") return it_file_export_transcript_title(inputs)
	if (locale === "ru") return ru_file_export_transcript_title(inputs)
	if (locale === "es") return es_file_export_transcript_title(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_transcript_title(inputs)
	if (locale === "ja") return ja_file_export_transcript_title(inputs)
	if (locale === "hi") return hi_file_export_transcript_title(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_transcript_title(inputs)
	return en_file_export_transcript_title(inputs)
});